import { render } from "./RahbariyatInfo.vue?vue&type=template&id=1b42ee24&scoped=true"
import script from "./RahbariyatInfo.vue?vue&type=script&lang=js"
export * from "./RahbariyatInfo.vue?vue&type=script&lang=js"

import "./RahbariyatInfo.vue?vue&type=style&index=0&id=1b42ee24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b42ee24"]])

export default __exports__